export default {
  b8f66a73dd67296edf7d6126839b8b00:
    '(Dostosowana w związku z walutą lub dniami wolnymi)',
  eba8e32b871086c08ac4b90ef5ede94b:
    '* Opłaty oraz daty płatności są orientacyjne i nie można ich zagwarantować.',
  fa090ada546b5deb33cdead006822e26:
    '* Opłaty oraz daty płatności są orientacyjne i nie można ich zagwarantować.',
  a60c743772480aaf26a3ee6fba11ba50: 'DST',
  '52fce318164dc60017ca67121172aca9': 'Zaakceptowano',
  '615a093396ed9c6f52cd7ece7217608e': 'Dostosowanie konta',
  '79dd431d35b370210a3dbeb1bb653d43': 'Nazwa konta',
  '8c66a974a95769447407c061a36d0824': 'Numer konta',
  '6a810f9427275516cc7ac687ea182f27': 'Naliczone odsetki od zadłużenia',
  '21df2d8134802290caddc9a8070e9d94': 'Naliczone opłaty za zwłokę',
  '7377dcc6989501c8299b7ccf697b731e': 'Naliczone odsetki od zadłużenia',
  dab81136f1c6e799c5626826349a8dcf: 'Naliczone opłaty za zwłokę',
  f752dafdd1cbcfd9e276ee02daed1c39: 'Wszystkie',
  '6a21e27ab1553bb3bf93e0a73e645087': 'Wszyscy nabywcy',
  '59a79bbd7cb65771c64f6c687b4c8103': 'Wszystkie waluty',
  '5cd2457bf9ea161b1d3a628bef3a1cb9': 'Wszystkie faktury',
  d7db3397d1ee87530b253bc69ebca041: 'Kwota',
  c7586d1e153c74713afd948b3048d03d:
    'Kwota wypłacona Ci po odliczeniu odsetek i wszelkich spłat należnych od finansowanej kwoty.',
  c3a614afd7dbee1c3e19828e0999b8c8:
    'Kwota odzyskana na poczet spłat należnych z tytułu innych faktur.',
  '57e646b300b4b551d662b0cd536a6ad5': 'Kwota do przelania',
  d35a870d0219f3f9cbde80ed0eb11aa1:
    'Ewentualne nadwyżki środków zostaną przeniesione na Ciebie.',
  de9800ff635c316938aece381c98b094:
    'Wszelkie zaległe częściowe płatności i odsetki można odjąć od należnej ceny zakupu lub od innych pobranych środków. Jeśli nie jesteśmy w stanie uzyskać należności w ten sposób, możemy Cię poprosić o przekazanie kwoty bezpośrednio nabywcy.',
  '3aeaa80d4eaafcaaf03a7a4d1c47bc2c': 'Zatwierdzono',
  '40cba7837184cb0c15ca4a7cc7b557eb': 'Zadaj pytanie',
  '2cab8574e420020ef12b4729f81e5d6c':
    'Dostępny limit kredytu na potrzeby nowego finansowania.',
  '85a6c2f454268a7b3c4156c070abc517': 'Oczekiwanie na zatwierdzenie',
  '99fb0198659b8076326d69a42670433b':
    'Salda są zwykle aktualizowane następnego dnia roboczego.',
  '0448c27d5574d95fc844e50416fc13a3': 'Pakiet',
  '84b730c6e665f3a83a96a8511b4f63db': 'Szczegóły pakietu',
  e03b84fcbe917d6adfa8bf31db40f9ae: 'Oddział nabywcy',
  '2be86945c7f60b651a0cf58d8e73dabf': 'Nabywca odrzucił fakturę',
  cdb5b8f6940144b32dc7f27b7700719a: 'Przelew nabywcy',
  '2e5e060fbc0b1324e5e2059482c65be6': 'Nabywca oznaczony jako: Zapłacono',
  e7094a08ea031332f2a7e7f94b214174: 'Przelew nabywcy',
  b8b64034058f45fe990f8377c7990c6b: 'Konto przelewów nabywcy',
  b58bdf039e33f8abf293173c9e0c1ee6: 'Nabywca:',
  '9c2c1e1e0ef092c2668b7ddf551d517c':
    'Tutaj nabywcy opłacają faktury. Tutaj można płacić za częściowe płatności.',
  '7cb0b1efd5ad2a5759542ea7b414faba':
    'Domyślnie należna kwota spłaty jest odliczana od następnych finansowanych faktur.',
  '0d1e94883caf8b30026ade5dd5c242ea': 'FK',
  cb1a025651df74878d8d5af1b99991df: 'Anulowano',
  '5bdcb598d6b9a3ccc8b04cf8b0fec15c':
    'Informacje o programie rozliczeń pieniężnych',
  '6fd54168f061cd9f269dbcbb29415486': 'Kwota opłaty',
  '252982cd07a2c1e75a9cadb781c4428f': 'Zwrot',
  a78a36ca61f82c4cde3e21bb4eb1bc20: 'Kliknij, aby skopiować',
  ffa075e58de62f4c4a7af41bb3645aaf: 'Zamknij',
  f7a61d011f9f4aa24be33b4ddb96eaa0: 'Zamknięte',
  a150472168406890d84a6a5c3c8a894c: 'Zainkasowano',
  '0743742edda54d26e47f9959ca4be4f0': 'Pobrane odsetki od zadłużenia',
  e706d0d09fc62c7ec9fd51f4963a1af5: 'Pobrane opłaty za zwłokę',
  '0b2194f7621b8a036308dce1647b982d': 'Zainkasowana kwota',
  '0ccb7eb111a7a0b5f47f72c526b7352d': 'Pobrane odsetki od zadłużenia',
  b1a3b2482cd668f631d724aac2dfc685: 'Pobrane opłaty za zwłokę',
  fbdc4c51ab56c2706190a13fa4d02f16: 'Wpływ',
  ba18fa9a0a1da454462f71c6e36139ff: 'Salda wpływów',
  '1103815eae13527faa8d51c83c20d17e': 'Szczegóły windykacji',
  '898e15d1fa445c9c37ca795f79029f6d': 'Nazwa prawna firmy',
  c16ee5d7a1e74972b7b98e206f1f5231: 'Kontynuuj',
  c05df0411bb18c405aaa68153432bf10: 'Zaktualizowano limit kredytu i faktur:',
  '1ca7e972f6aca1aa19fdf76ee58a56b2': 'Dostępny kredyt',
  '4f023c0edbea4a6dbbda7d4a2533e5b1': 'Limit kredytu',
  d23014cf5a5e7f8c6440b96692831aa8: 'Nota kredytowa',
  bb1f8a35aeec1e9eadef6c63117a19d9: 'Wykorzystany kredyt',
  '207df9f33356e378a1ff2ef7b62becc7': 'Dostępny kredyt',
  '62337ac81597ce5c99fa74c6f57cbbf5': 'Limit kredytu',
  '208d5141343637870387b27db87ccf05': 'Limit kredytu został przekroczony',
  '0e27340c6eb226df1076c4f8930d2289': 'Wykorzystany kredyt',
  e15a66f111bc879c77f24943a94d19e7: 'Waluta nie jest obsługiwana',
  b1e5986f972b7599559dea22cfeae8fb: 'Waluta:',
  '90322bb69cffbb5d303e93c3a98cc595': 'Rabat dzienny',
  '6d8cbcbdafc9fbd774aa01f9f20b9112': 'Stawka rabatu dziennego',
  '05042f185370ad98dcaa943ec8b2fbd1': 'Dzienna stopa dotycząca zaległości',
  '9e268b45f182ad1851f03539be6ab29c': 'Dzienna stawka rabatu',
  c2191b6160c46ed7a4b05cc0279158f3: 'Dzienna stopa dotycząca zaległości',
  e2d9ef555d350e16239f4dfc92842fdc: 'Panel',
  '106202929cf48a3de3f20b3255365915': 'Data',
  '2eca727eade526acc715c2e5605ebc7e':
    'Data całkowitego rozliczenia finansowanej kwoty.',
  d8b0ba98f5a8b8a8e0dfe049222009ad:
    'Data zakończenia 30-dniowego okresu prolongaty.',
  b914f3ab262190a5dd60478fa6b7b828: 'Data odrzucenia faktury przez nabywcę.',
  d5c0c15ebf4ff694fdd870b89754c7cf: 'Zaległość w dniach',
  '1e1e68c46e0d719364bd445b1d605144': 'Zaległość w dniach',
  bd50c01a22cae65be4d588abcae65a90: 'Odliczenie',
  cbe998aee5abfa07da9ece7ae8c67be1: 'Odliczenia',
  d706035ec5f053ca33b234ddec228ab2: 'Opis',
  a39bf2f30994908fe95498524b423d43: 'Szczegóły',
  '193d60da437b58b24ed69a5683c1ffcf': 'Rozcieńczono',
  '57dfeb9af6705752d57d3b50b3a2f401': 'Kwota rozcieńczenia',
  d07e29091188f3b0871dc7712eee7255: 'Typ rozcieńczenia',
  f8a1650d7f4ba3f69777ad4352ee9288: 'Bezpośredni przelew sprzedawcy',
  bba135fe5cb16d1a6c251e9fd5225eff: 'Bezpośredni przelew sprzedawcy',
  afc1c7dfc9315e856f8da52e2450182b: 'Rabat',
  '26e7eb298420701d5a03c53fe096cc0b': 'Zakwestionowano',
  '43cca9c1b76ebf869c7bf22fff271689': 'Filtry statusów dokumentów',
  ce73b429141cda25571c88d9b0c78224: 'Status dokumentu',
  af13cc2ad0a7337c45420f75b7d5a668: 'Pobierz',
  '8475be8bb8249000118af931ae75c373': 'Pobierz raport',
  '90567e36a540e51806d7790eb195b1d5': 'Pobierz wszystkie faktury',
  '2a669c26b8086630dc4da5c2ee81e70c': 'Wersja robocza',
  '72015a772310560b755bd03132a543b2': 'Termin',
  f12ae1ac50389e2b7470ae1f3d1a0795: 'Termin',
  aebf0bb5575e8a95e1eaa6f0de3d0416: 'Zbyt krótki termin',
  '6def6918bd02ae5117332f4262cecb52': 'Kwalifikujące się',
  '6426c30d14da5d40d03fc7e85d0c9677': 'Status rejestracji',
  cb339c5c02cfb087fc8d393f917379df: 'Błąd podczas ładowania panelu.',
  e9994b26424cb4bce5059d05e094df8d: 'Szacowana opłata',
  f159aa99d4a54cda8b884530e2ad2a1b: 'Wykluczony kraj',
  b5cb31ac9c7d1871e9075efc1f271536: 'OPŁ',
  fd9d568c402dd04e0715e877d76f7da5: 'Wartość nominalna faktury.',
  '5bbfbbeb3649c8a75f2e910414f2a448': 'Niepowodzenie',
  '817f1fe84c2d87894bc374681814abbf': 'Nie udało się załadować {title} -',
  '7932079ce6ea928bfa77efd91578312d': 'Opłaty',
  '85624d3e9c7eb6862afe19de8d77dc45':
    'Filtruj według waluty, aby wyświetlić sumy łączne.',
  '110df72171aeef47da3fd84ea2a1a10f':
    'Prognozowana data płatności jest zbyt odległa',
  e5af505b37031920b08edb84df19b5ec: 'Data wpływu całej finansowanej kwoty',
  a4e77d51ea7969a9e1fd98d59f99c158: 'Data pobrania całej finansowanej kwoty',
  '6dd341953c8c405c70878a457622cf55': 'Opłacono',
  '42e20c6bb1dc82fbdbd889f769850320': 'Wpłynęła finansowana kwota',
  cab921680af6ff282ce37398b0b231d4: 'Finansowana kwota',
  fc0347ceea208298049efd79021475a2: 'Wpłynęła finansowana kwota',
  cb293fb8bb3c321741d7350d5b4ff8f3: 'Data wypłaty',
  '55d900eb37f97b684c0bd5821f161216': 'Sfinansowane faktury',
  '6ccedf75a47ac6f5064b12a63f3e0844': 'Finansowanie',
  '14e5c248a47ad6166a23fb7d4d60062a': 'Wyjątek od finansowania',
  '5ca89ce217f3bb07293db00a42c10200':
    'Powody niekwalifikowalności do finansowania',
  eac067c62df8f46d6bbdbfc4f9e69803: 'Przegląd finansowania',
  '08109e77ecbcb34d6e7391b293d8ba20':
    'Prośba o finansowanie zakończona powodzeniem',
  d5ec85821723434aba05986044ebdcdd: 'Status finansowania',
  '3447158e3ace443dbe27556e07c88639': 'Filtry statusów finansowania',
  '022848540bf0e01453be6cf79843aa67': 'Termin płatności sfinansowania',
  b4a59826d5bfc276fa88bd00abac615a: 'Szczegóły sfinansowania',
  '8fcddea1bfb1a15dd931657f61c1b1cd': 'Termin płatności sfinansowania',
  e74f45b44aadcdd084b5cbdd3560f515: 'Data zakończenia prolongaty',
  '5434cf75f987ef76dbdc544fa1e32096': 'Sposób płatności',
  cb9f9412bd12122bb088124afccf738b: 'Jak spłacić częściowe płatności?',
  '9ad57f0b683fecb097c09bedebf68a45': 'Jak rozwiązać należną spłaę:',
  '993620b9fcdc8e20ebb0a0fe3b069464': 'FRA',
  '7428e52e7eecc9d7211ad241a469cd65':
    'Jeśli uważasz, że to błąd, skontaktuj się: <a href=',
  '4bc3804f1b4b93cccd24f86f94c4d566': 'Ważne informacje',
  '5de88f4d34f61b9e39961eecbe0ef8d2': 'W toku',
  '313b15a4fdfa2368015e2eb67416af2a': 'Program nieaktywny',
  '7b6a003ceca7fe7fec85daae919e800b': 'Niekwalif.',
  '6cf0784c1ac918c22cd402e0cb558749': 'Niekwalifikowalny powód',
  '65cb9c651d2d9fb8941050a08add03c3':
    'Nie kwalifikuje się do wcześniejszej płatności',
  '0c184dc925e7a1c0bcb3066929300d6c': 'Niekwalifikujące się faktury',
  c555faa7b0b745638bb3ea785ee10137:
    'Ostatnia aktualizacja wyświetlanych informacji:',
  b7311d63c44566a8562d92720cffed2e:
    'Niewystarczający wskaźnik wpływów do faktur',
  fb07cb1753537f6969513f2d5fdb7993: 'Kwota odsetek',
  '1938e208f65e66474dc4148c3fa7da08': 'Odliczone odsetki',
  '42094e40339ac5c0957a980062c47659':
    'Naliczone odsetki od częściowej płatności',
  d9580a19710f07e8c72c215b1270ca57:
    'Odsetki naliczane przez HSBC od finansowanej kwoty.',
  d73af19f82bdaf892c8ab4b1a020fe55: 'Odliczone odsetki',
  bf4c9a1d5b84c3b2efdc3dd43f95b9b6: 'Odsetki od zaległej faktury',
  '47a565198d287d0864339c077819a361':
    'Odsetki będą nadal naliczane od zaległej należności do momentu odjęcia od następnej płatności na Twoją rzecz lub otrzymania bezpośredniego przelewu.',
  '3c4be400f728da4526de626653d56ccc': 'Faktura VAT',
  '70546e9227f592c24d3c491756cb901d': 'Numer faktury',
  '49ab71fcac9df0f0fe5bad215adbc318': 'Kwota faktury',
  '6b9515d101794c31e38ae60d092fdc03': 'Data faktury',
  '2548c6a52ce9e1bffef7aad14530f490': 'Sfinansowano fakturę',
  '42bb3ba3a1cd691726744d3a1a8da732': 'Przegląd finansowania faktur',
  d6d9690b8dbcb32f5bd6d620c89ffadb: 'Limit faktur',
  '734ed127b3d7226c75e8553c0711367a': 'Wykorzystany limit faktur',
  '3d2825494935cd9b356babbd5d0fbdc2': 'Łączny limit faktur',
  '64a857c3c7502d4299e4d8798fc9dc05': 'Numer faktury',
  da2db17c9b22f995d6673a754d998fc8: 'Zaległa faktura',
  d729bd1bdced62265cd4ecd7131ef94e: 'Odrzucono fakturę',
  e14208d4378a3378be8b27eb15984fc6: 'Rozliczono fakturę',
  '89e202e1d2ba477fb79304c9ea0a989e': 'Status faktury',
  '54d8df173250a197fab1644a0d0a772a': 'Kwota faktury',
  '2f0b0caf0ba91c42ecfbfebe00d85e4a':
    'Obecnie nie można sfinansować faktury. Więcej informacji można znaleźć w sekcji Powody niekwalifikowalności do finansowania.',
  '358a6ccfcf92e3d5cf8f6aa3861cd4d9': 'Waluta faktury nie pasuje do kraju',
  d0da9e977c8b309f93ee378de34fb251: 'Data faktury',
  '52814d7b6ec80234a8e2ecc4b5fda5b9':
    'Data faktury przypada przed najwcześniejszą kwalifikującą się datą',
  ad0ab15468b719694f3193d0649ad9eb:
    'Data faktury jest późniejsza od daty anulowania placówki.',
  fc9e80713aebb3d820d888f0755fedde: 'Faktura nie ma subskrybowanego nabywcy',
  e17cbec04e7786361eff9da629f09bb7:
    'Data wystawienia faktury przypada w przyszłości.',
  '8d1bfc3f25976dc4887bfbd7bc98ed8f': 'Faktura została anulowana.',
  '89f842841b4ae213259b94a5411453f2': 'Faktura została rozcieńczona.',
  ddd4d4560a24bcd3bb32dffdd8986c03:
    'Faktura została sfinansowana w ramach programu rozliczeń pieniężnych.',
  ab5303505d045929abb1256607ca0d4d:
    'Faktura została opłacona w całości. Nie są wymagane żadne dalsze płatności.',
  '3e159746cbdfda07b2f45750941e26f6':
    'W przypadku faktury złożono prośbę o finansowanie.',
  e8a7d355e6efb25006f6e4c50fde715a:
    'Faktura ma status niekwalifikującego się dokumentu.',
  '8204c52c01b05791dc3e4c59ac352978':
    'Faktura nie została rozliczona w całości i upłynął okres prolongaty',
  d87ca92704bcfb34fa4ac08a4d24147a:
    'Faktura jest obecnie niekwalifikującym się dokumentem.',
  '2bfdce2f3dd38d4d167510eb5c9434de':
    'Faktura nie ma daty zakończenia ani ostatecznej daty zakończenia',
  '9ab3b9c101b4053a3818c764fcfcde35':
    'Faktura jest zbyt blisko przewidywanej daty płatności.',
  c43016d28717b24a7ac4bd2c99f26c0d: 'Faktura jest nietypowa',
  '4df9e5dc4fbad79cc905b0b1f43eaa8c':
    'Faktura została już oznaczona jako zapłacona.',
  '4ac6a84899b9b6422f4e92b091a5448a': 'Faktura może być duplikatem.',
  b1f771da19efea2f0fa6a542823231b9: 'Faktura kwalifikuje się tylko częściowo',
  '4217948ca113ee4158d5dd4c07d71624':
    'Faktura uznana za rozliczoną z niedopłatą',
  b6d4f7035794b3bc3a0be36237fedd2b:
    'Termin płatności faktury nie mieści się w akceptowalnym zakresie',
  '7c3fa246e8cca51273ddf5062ff2d593':
    'Termin płatności faktury jest zbyt długi',
  '90d9ac20dda384e9c07554d29b143bef': 'Wartość faktury przekracza limit',
  '4b36f0be327fdca8d54126cd57095a13':
    'Numer faktury / zawiadomienia o przelewie',
  cb5bf06bec8dcbfb20319ad13bdf57fd: 'Faktury',
  '8089283aad9294aadc2bde165ccc78c1': 'Data wystawienia',
  '3a4123f9c604369ab18781f7492f9293': 'Data sporządzenia',
  f2cc23904a2b3bf60e1c059712a12cd7: 'Ostatnia data wypłaty',
  a94bc4d4df1d56c16e25493e22684412: 'Dostępny limit',
  '92f97c843d499a1559828ba0a9134e24': 'Wykorzystany limit',
  b5dd8e130d88698834ee00464f01cea4: 'Dostępny limit',
  '08f8f98f90b3eb19ef77ad80b322921f': 'Wykorzystany limit',
  '4a739fa0b571805cc56fc4080ea82fcb': 'Ładowanie...',
  '24cc5627dea65e22f9279be9522a06e2': 'Kwota pożyczki',
  d0dcb336e1d5256ceb7d9a8b8c5a478e: 'Termin zapadalności',
  '41dcb6cef39f12b7e13ec8e3e504b3b3': 'Data rozpoczęcia członkostwa',
  d26429adfb846303cbd889879b23e1ba:
    'Pieniądze uzyskane z płatności nabywców, zawiadomień o przelewach sprzedawców i/lub potrąceń przed okresem prolongaty i/lub po nim.',
  '2e5b5d9440ab665bfd8ad63a16c6738b': 'Zapłacona kwota netto',
  '3d18f259085bdd0acd2ffebd2cc95e4b': 'Zapłacona kwota netto',
  eb094ee2b99cdffc1c6c4db9349d0cc2: 'Nowa kwota',
  ff47fd34d6a57673fa57ad67ec26feb0: 'Następny dzień roboczy',
  '325c48f099844279c0cf48584de42e64': 'Brak ostatniej aktywności',
  '8ab2d59e3a0a751ccbf443e0b04fca48': 'Żadne',
  '7457575d324c4b8dada2e13c0f0fe5d5':
    'Brak aktywnej rejestracji w programie Cash',
  '97d4ed503f1a63577fc5befd1c7a2663': 'Za mało historii faktury',
  '38e96e9d0dcbbe1b0f22950fdde4d82f': 'Za mało faktur w poprzednich miesiącach',
  c9e2ce8da559465a8596317c35e8f3a4: 'Za mało zapłaconych faktur',
  e6f890deafa579eb0c24603c3101c1c7:
    'Uwaga: salda są zwykle aktualizowane następnego dnia roboczego. Jeśli potrzebujesz aktualnej pozycji, utwórz zgłoszenie problemu.',
  '83070a059f10db1515ac922bf3433158':
    'Liczba dni po terminie zakończenia prolongaty.',
  '9d40ba58bf72a5bf003cd0d9a1fac469': 'Dostępny jest jeden raport do pobrania',
  '2778717f6acbeb1edaac6a2656b478f3': 'Otwórz',
  '2c825aed78dedab44e18d2c0e60e7cf7': 'Inna opłata',
  fad92e97e692758c0d0a9b5730663894: 'Pozostałe odsetki od zadłużenia',
  '6c2e55b7a6b08252eb4124bd2f75b5df': 'Zaległa finansowana kwota',
  '9eab1baddf2537312408088fc54f21d5': 'Pozostałe opłaty za zwłokę',
  bfba12a2c234532c0af24a4ad6831ab6: 'Pozostała kwota łączna',
  '2e16b3dff2a0a8f233a1b8b62c1b38ec': 'Pozostałe odsetki od zadłużenia',
  '3b77ef3a1af4e72eb5072092bae35ddd': 'Zaległa finansowana kwota',
  '2f9a3de6940f818fe0376e4aece59512': 'Pozostałe opłaty za zwłokę',
  '6f79eea38bff17917740a69116270074': 'Zaległe',
  '1fdf67a5f18bc408f2ad55412310c39f': 'Salda zaległości',
  '848ac8c39b11a751d697a383303e6109': 'Zaległe zadłużenie',
  '8d1e868665fc24a46f0cf55187f72218':
    'Zaległa należność zostanie zgłoszona zgodnie z przepisami RBI.',
  dc14337c43c60e68f4766cb5dd95bbc2: 'Informacje ogólne',
  '5b885084a5067d7fb4372cef38d8a82d': 'Zapłacono',
  '830b95d305cdc61a66cdf75ebff1d737': 'Zapłacone przez nabywcę',
  '6444796646c95dbc2cd1cb646e41293d':
    'Część kwoty nominalnej faktury, która została sfinansowana zgodnie z wartością procentową płatności zaliczkowej zatwierdzoną przez HSBC.',
  '92cacee97a99fe8c26a5c1999ae51293': 'Dane uczestniczących nabywców',
  a39314e5897b8baaa51ca296610ec30c: 'Warunki partnera',
  a6acd5f03fda9c8dc607e59d8be08320: 'Opóźnienie zatwierdzenia zobowiązania',
  e6249829dadf637c4092e4a900df529e:
    'Zobowiązanie zostało zakwestionowane przez nabywcę',
  '07ed468d28d8e8437d8ec64036b96c03': 'Zobowiązanie zostało odrzucone',
  '042b8dfb88f7045ca9145bbcccf79200': 'Zobowiązanie przypada w przyszłości',
  f8768f5b4055c45a4d30591bea9cc7b1: 'Zbyt stare zobowiązanie',
  '8755bbc212b541efb6576f39f3f0f51f': 'Przydzielona płatność',
  '8744ee10540166dfc39db2a6859a9ce1': 'Kwota płatności',
  '56133aa371eb0132334e4867479be942': 'Szczegóły płatności',
  '28d03c82bf3e37e2ff159922908c1ecb': 'Zaległa płatność',
  '2dd7164df606f9b42beefaba031b06f7': 'Płatność otrzymana',
  '4e62b46d2c536f88dcd8e6c6a70d67ce': 'Płatność potwierdzona przez sprzedawcę',
  '661711004f06b0d9601db365679be130': 'Kwota wypłat',
  c6e4c2b52f344cb3dc4f21eb1af772db: 'Data wypłaty',
  c28381c5e3ed0ea4f48a4dee4ebd6f40: 'Odsetki karne',
  '0fd036622716f275c3e14c5a14faa65a': 'Oczekujące',
  '5d6bc30e401a38c04005a5d1962b46bc': 'Oczekiwanie na rozcieńczenie',
  '8cf3479829ba47a8a4123895d0088eeb': 'Oczekiwanie na rozcieńczenia',
  '270b56fd05f72407ca0607b6162d0b10': 'Oczekujący kontakt',
  '4a78218416ca45d97b5633b37ae3f638':
    'Stopa procentowa, według której będą obliczane dzienne opłaty za cały termin płatności finansowania.',
  b586a5468c7070bf1717593ea84fa607:
    'Stopa procentowa, według której codziennie będzie naliczana opłata powiązana z zaległą finansowaną kwotą w przypadku zaległych lub sfinansowanych i odrzuconych faktur.',
  f8c94740abd5c69fb813bd0f4827de0e:
    'Jeśli potrzebujesz bieżących sald, utwórz zgłoszenie problemu.',
  '34645fa620cae4187f27d9f96c172f26': 'Przekaż kwotę',
  '4c54e70d0c88c94d16c03e32519d6be7':
    'Prosimy o przelanie następującej kwoty na następujące konto bankowe:',
  '01734a7316427fdcdcd4f937cda3802b': 'Zaliczka',
  '8181a4caaa4413f5585df4a5a5f979ba': 'Poprzednia kwota',
  '500fc4731dab800a878b33906d9332fb': 'Konto windykacyjne programu',
  '7327113634d1f5f4f68632dceebfbc6f': 'Przegląd programu',
  d95ebfb51a485293a134b1038d332a10: 'Program aktywowano',
  '6e5f8b0b9bafba4816b7a0430194289a':
    'Szczegóły programu niedostępne dla panelu',
  '98feb2c86a81b8caeeaa30966ba34636': 'Informacje o programie',
  d202f03687187e744a1f4b11a1e5f8e4:
    'Płatności za faktury zakupowe, które nie zostaną zainkasowane w całości do oczekiwanego terminu płatności, generują płatność częściową. Płatności częściowe oznaczają naliczanie odsetek w wysokości 1,5x dziennej stawki rabatowej, a Ty masz obowiązek spłacić oba zobowiązania.',
  '521689b600b8da5b0a111b89dea72126': 'Uzasadnienie',
  fe7bd622a1efcec03eb86dabb9395936: 'Odebrano',
  e84203a8833e4d0d92faf89f4107bf11: 'Spłata z prawem regresu',
  '7e7c742f83bcdbd977c9e32d053b3f52': 'Kwota zwrotu',
  b0be744ae1f6312f16990bbd92a87aea: 'Data wystawienia zwrotu',
  '39591f42bcdde6d7ce9409e167aa7e80': 'Termin płatności zwrotu',
  '654d6dcc141079bc84500fd14ca5087d': 'Kwota zwrotu',
  '50618267079bccdc7f15c8a8e8aa6b73': 'Szczegóły zwrotu',
  '5b2508eaa0c48b46fe2034cdf1916867': 'Data wystawienia zwrotu',
  c0a6a91e7ca80af9de47097b06dc7618: 'Termin płatności zwrotu',
  '4a2875439ab289a068abb9ea3b567bcb': 'Odrzucono',
  '592b34cdfa2e51826b32a0783e0edce3': 'Odrzucone przez nabywcę',
  '807d35f105b65ab2795c4f8e51795f3c': 'Odrzucone przez sprzedawcę',
  aea4dd208e871d7ca0051b0ec38c3068: 'Data odrzucenia',
  d64ed4934fbf68a8f716467b0adf89ba: 'Data odrzucenia',
  '5a77de3b287a92494be077c197f37581':
    'Pozostała finansowana kwota do pobrania lub zwrotu.',
  e442b864bf745a75477ea0ee88bc15c4: 'Termin spłaty',
  b4f924c1a7c5d182fab9d3088cc22471:
    'Kwota spłaty jak w dniu zakończenia okresu prolongaty. Nie zmienia się ona w celu odzwierciedlenia jakichkolwiek zwrotów dokonanych po tej dacie ani nie obejmuje zaległego zadłużenia.',
  '636a65df0d453f8e6f73e87e65276c5e': 'Należne spłaty',
  dc20cbfb76d220c108241a451bc3faf4: 'Informacje o instrukcji spłaty',
  c8c021e2a7c9064a0b97db4aa96f6623:
    'Należne spłaty to łączna pozostała kwota spłaty, którą trzeba odzyskać, wynikająca stąd, że nabywca zapłacił kwotę niższą od wartości nominalnej faktury i/lub odrzucił fakturę po jej sfinansowaniu.',
  '45b60e22719c12291932bf09db0df5cd':
    'Należne spłaty to pozostająca kwota łączna do odzyskania wynikająca z jednej z następujących sytuacji:',
  ba093b1421452b3afdebbebedaeae552: 'Poproś o finansowanie',
  '34f8f9968ec0d7f91e558e906a7de982': 'Żądane',
  dc1650cfbadb05f8fb6357692e48ee71: 'Poproszono o finansowanie',
  '563dff6e09a85e6fb07b91c48e9d0fca': 'Zatrzymano',
  '15a9cd2bd0e2cda9a8f399b4a55ffed2': 'Zatrzymana kwota',
  a476316a89541d1aa71d5b5366874e13: 'Zatrzymana kwota',
  '328f6585a0e78a96deefc0661474248f': 'Ponów próbę',
  '626efcff97ad72e5eb9cc8a602aec8bd': 'CP',
  '70c8ea0dc7c6d6c7e9cffaa1c9e893fc': 'Sprzedaż',
  '87d4fbccb70028d34d4260b9527e3fd3': 'Szukaj wg numeru faktury',
  '3215999493db188b35242dc4f4fd8fb5':
    'Więcej informacji o spłatach znajdziesz w informacjach na temat programu.',
  '69f43575c3a51e94605eb75b75f7b563': 'Wybrano',
  '56a1c7c4a02e9985745969563a80799f': 'Konto spłat sprzedawcy',
  dfc8eafdd7ec598ceb6d2f1bdf68fd50: 'Wysyłanie',
  '3e7dc5ef26363b6a0176875cb5d6fee0': 'Wysłano',
  '95d54926719f1071b2fa640f1ba23d3e': 'Rozliczono',
  e243f36392a7f264d830f04f21aa8972: 'Rozliczone faktury',
  b548572d4123e3a569d27e4676664dad: 'Częściowa płatność',
  '6e09ada7e33833d259370b0cc900f082': 'Kwota częściowej płatności',
  bbb44706c9f67b578a7aac0a5ed30e40: 'Odliczenia z tytułu częściowych płatności',
  '8be3fe50247f2256bd4aa1eb8bc67fae': 'Częściowe płatności',
  '46bbc145b1f85c082950c768ade012f6': 'Kwota częściowej płatności',
  e66e6d9768e8f489c05951ee70ede350:
    'Coś poszło nie tak — niektóre funkcje panelu mogą być niedostępne. Spróbuj ponownie lub skontaktować się z zespołem pomocy technicznej, aby uzyskać pomoc.',
  cd969f183dc619b5716067cfda39c055: 'Numer rozliczeniowy banku',
  '17939071126e9e41921d79b837f63297': 'Nazwa dostawcy',
  '750d4460b260343039f9bc71b66a231c':
    'Dostawca został uznany za niewypłacalnego',
  '7f6562457845bcf84c0cfece3d1eaa51':
    'Dostawca jeszcze nie został skonfigurowany w programie',
  '8876cfd0d8d60c5defe5e40d9d563da3': 'Pomoc techniczna',
  '9ef0225cd6b858ef31c2f3c1bd312baa': 'Warunki zaakceptowane przez:',
  '4a8bbcc5abd16a59fa1cc5548cafe8ac': 'Warunki usługi',
  '1294cf929ec55581954a79948592dda9':
    'Data aktywowania finansowania w ramach programu rozliczeń gotówkowych.',
  f51144e4468390a486d41b4db66fc243: 'Nie udało się pobrać pliku.',
  '692eebfa29fc5d4a7090a22f5aa668fd':
    'Maksymalna liczba dni, po których można się spodziewać płatności od nabywcy, zatwierdzona przez HSBC.',
  d438da584c455e727642a303917e690d:
    'Pozostała kwota kredytu, którą można jeszcze wykorzystać. Jest to różnica między limitem kredytu a wykorzystanym kredytem.',
  '78c4e85a6398bb0b164ed2479f1faeca':
    'Łączna kwota faktur, które są obecnie finansowane w ramach tego programu. Kwota ta jest obliczana na podstawie limitu kredytu i bieżącej kwoty sfinansowanych faktur.',
  '43fc53cbc779fd0ef3f42d350a2274b5':
    'Łączna kwota faktur, które mogą zostać sfinansowane w ramach tego programu. Kwota ta jest obliczana na podstawie limitu kredytu i bieżącej kwoty sfinansowanych faktur.',
  '9c9fa02e1129e31e3423a0dfca81732d':
    'Łączna kwota pieniędzy zatrzymana przed rozliczeniem faktury.',
  '13f271ac486faca89c1944226ba0efff':
    'Łączna wartość nominalna wszystkich zaimportowanych faktur.',
  '4c1f04bf5bcde1f8e3532de0896377fe':
    'Łączna wartość nominalna faktur, które uzyskały status rozliczenia w związku z ich pełnym zainkasowaniem.',
  '8cbe218cd17eada461e5da93d4cbd541':
    'Łączna wartość nominalna sfinansowanych faktur.',
  '565c255165bed2ff2640d0e42369c62c':
    'Łączna wartość faktur niekwalifikujących się do sfinansowania.',
  '3463c9dcfdb9aa161c07a692207786bf':
    'To konto nie jest aktywnie zarejestrowane w programie Cash.',
  '1fa3524cbb92859434dcb01b98f71c7d':
    'Aktualizacja następuje zwykle w następnym dniu roboczym. Jeśli potrzebujesz bieżących sald, utwórz zgłoszenie problemu.',
  '0678bf00ae9e72b3053f3d5f0f64e639':
    'Ta wartość odzwierciedla Twoje najnowsze saldo częściowych płatności wraz z odsetkami.',
  '32460c75c8ea6599665b77eeb2df37a3': 'Wraz z',
  '603e4b3b3ac7b888a06548d14435bc25': 'Zbyt wiele rozcieńczeń',
  d356429f9bd0a4a6036707d99bf5e2b2: 'Suma',
  '7cfb9dc5c11c2fb869c897552b563d14': 'Łączna kwota wpływów',
  f786c8a1095bdf155841d510bb53142a:
    'Łączne odsetki z tytułu zaległego zadłużenia.',
  '4f25d1096076868bc590da9f8a26cf55': 'Całkowity limit',
  '230bd56af0acab75194f58b46a763535':
    'Łączna kwota wpływów z płatności nabywców.',
  '8f78461d739b4d6d46f961f352000cec': 'Łączna kwota wpływów od Ciebie.',
  b62dd565f60dc6172605d8db223510b9:
    'Łączna kwota wpływów z przelewów nabywców, przelewów sprzedawców i/lub zwrotów, w tym wszelkie odsetki z tytułu zaległego zadłużenia.',
  '8dfcacc58acbafda8eca3d58c4d8a447':
    'Łączna finansowana kwota względem sprzedaży.',
  '1c27145f9530e0e06436fea1e3e645cf':
    'Łączna kwota niefinansowana, zgodnie z wartością procentową płatności zaliczkowej zatwierdzoną przez HSBC.',
  d6c89215b3fd6857262efc2039d78dec:
    'Łączna kwota sfinansowanych faktur pobrana w całości.',
  a069138e83a8b4cb7e81145689155826:
    'Łączna kwota odsetek z tytułu zaległego zadłużenia pozostała do zapłaty lub zaległa.',
  '45f2193bb0825a19bb1ede965692c3a4':
    'Łączna kwota należnych opłat za zwłokę. Opłaty karne są naliczane codziennie.',
  bc37640f0d55a99b3f0b8bce05a2f0d1:
    'Łączna kwota uregulowanych opłat za zwłokę.',
  bec87347063c8e0b9fac78e381fa0bff:
    'Łączna kwota opłat za zwłokę pozostała do zapłaty lub zaległa.',
  d649fb9a0971deaa127067341f59be91:
    'Łączna kwota odzyskana z innych odliczeń od faktur.',
  '28fcda8475061ec7eb4894565e49fc87': 'Łączna kwota do pobrania lub zwrotu.',
  d6b59ced2fa8fba56e7e9c3c451fd409: 'Łączna kwota wpływów',
  '04296a7ba8cd0ba0cea8842ef2a2e5e3':
    'Łączna wartość nominalna faktur niekwalifikujących się do sfinansowania.',
  '02bd64f3a39f4190918d46eb0e86a1c6':
    'Łączna wartość nominalna faktur wysłanych do nabywców.',
  f0164c47e6c3d2497856505cb08e6e4f:
    'Łączna finansowana kwota pobrana w drodze przelewów nabywców, przelewów sprzedawców i/lub zwrotów.',
  d4867ee77e79ded226c07918b9393715:
    'Łączne zapłacone odsetki z tytułu zaległego zadłużenia.',
  de4c28160afe1ab48bcf83be49bbb196: 'Całkowity limit',
  '9c9f73042961fc50756dc8ae2bbe2a6b': 'Łączna pozostała kwota',
  '8fc4a8a140b022c2b3e062321fa9aaba':
    'Łączna zaległa finansowana kwota i wszelkie odsetki z tytułu zaległego zadłużenia, które masz spłacić. Może to być spowodowane zaległością co najmniej jednej sfinansowanej faktury lub odrzuceniem przez nabywcę co najmniej jednej faktury po jej sfinansowaniu.',
  fecdb72e34cebfadf037b45b596d90e5:
    'Często zadawane pytania dotyczące programu Tradeshift Cash',
  '528a7c5ab621e9a113ff3fa6e16323e5': 'Szczegóły transakcji',
  e00ab25ba9a337b2f39d3d7dc06790c1:
    'Nie można pobrać faktury w formacie CSV. Skontaktuj się z zespołem pomocy technicznej',
  c8415d81378085ba3933015b8f5fc768:
    'Nie można pobrać umowy. Skontaktuj się z zespołem pomocy technicznej',
  '64580a198c861aa0226c91b28f8418aa': 'Niedostępne do sprzedaży',
  '5d7f86753376a21d28b5c1ad07c7d149':
    'Niezapłacone faktury po tym dniu uznaje się za zaległe i rozpoczyna się codzienne naliczanie odsetek.',
  '9d632e72031eea3767881d6c3adcfe54': 'Wykorzystany limit kredytu.',
  e871a6882109bd7ef07827882236c8db: 'Wyświetl umowę',
  '2ac548c28faaa41283f9d6b7606a4844': 'Unieważniono',
  '0bcb6eb0e07f04a47296d8c341dd94ad': 'Witamy w aplikacji Cash!',
  '78eb58937961a18929a623397b544a01':
    'Możesz uregulować saldo należnej spłaty, dokonując bezpośredniego przelewu na konto spłat (wymienione wyżej).',
  f347abf54f65274a614a9ba7515dfa98:
    'Za pomocą aplikacji Cash można monitorować wszystkie wcześniejsze płatności w jednym miejscu',
  '0b28e75aa5587b8f49edaa7e620b5cf0':
    'Twój program rozliczeń pieniężnych jest aktywny!',
  '7807cbebc0a0ffe93df0d4b4f626eed5':
    'Twój program rozliczeń pieniężnych jest nieaktywny',
  '6e6e06469dd953a124d718cd2307e32c':
    'Twój udział w programie Cash nie jest aktywny od {date}. Skontaktuj się: <a href=',
  '626afbd7141286d15df45bccdb695a66':
    'faktura finansowana zostaje odrzucona przez nabywcę przed końcem okresu prolongaty (codzienne naliczanie odsetek po dniu odrzucenia)',
  '5b2ecfd8f9f07ffbb60c5f166959f789':
    'faktura finansowana pozostaje niezapłacona w chwili zakończenia okresu prolongaty (późniejsze codzienne naliczanie odsetek) i/lub',
  '33e67e73d7f54aaee31e6040f873be79': 'zastosowano do odliczeń',
  a9798a3e063111de4d4768c363bdc267: 'zastosowano do faktur',
  a5be13d3bfec5fc92521a841009db3c7: 'numer konta bankowego',
  '736c1e36ac779a73ff4fddd19d82008c': 'dzienna stopa procentowa',
  ab53acde68c117f8fbfff6a8901de083: 'dzienna stopa procentowa',
  '4c584eabd4260d69914ac993cc4db5d2': 'dni',
  '047dbee224da5fb4ecfc21268ffd3115': 'termin',
  dd051262964c80130a2e9023ff933d89: 'wcześniejsza płatność',
  bc55e8a10310a96eeda133ddf159303d: 'przewidywany termin',
  '0c38a7cd8b860eb533f8f20ba93a6f0e': 'za wcześniejsze płatności',
  '932d9bd46daba4d09f361717c0ec03ab': 'finansowana kwota',
  '5e82566144af4903b40303fc3d1c799e': 'data wypłaty',
  '97048ad7f0d40ee95f476fdd4c7bf81e': 'okres prolongaty',
  '0a6949f0e73bc3c42b0e93fe10e63fff': 'płatność w terminie zapadalności',
  '2db524546615d120af0adf844a6e1bd7': 'z',
  '99c2f4783bb6821d84ad17a22f556813': 'opłaconych',
  '7555b72d3b4ffe69558b68b3cb86b954': 'w*/*',
  c138be463a457afe89e5ecfefc6a3dc9: 'zaległe noty kredytowe',
  '37f59e13afd5455cf130060ed55f4976': 'kod banku',
  '1e5c6ba6010146f42f6fa180329cf2dc': 'termin płatności',
  '763d4d3568ec0349aa3c3dbe3064fd59': 'na następujące konto bankowe:',
  cf4edd5f38054a752994e3242a1f3807: 'kwota łączna',
  '3c9f634310f5e3de42b79ee83d20923c': 'łączna opłata',
  '573b1b7930d8030d1669945f2c34992a': 'przelano do Twojego banku',
  ea0cb39e8c47c1bcafa2a9e737db4cdf:
    'zostanie odliczony od nadchodzących płatności',
};
